var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurNaturalRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 606,
    height: 258,
    viewBox: "0 0 606 258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M0,135.615V258L606,122.312V0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(144.825 53.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M142.246,132.448c-.586,14.069-4.458,20.993-12.823,22.862-7.816,1.746-11.37-3.432-10.771-17.672.586-13.873,5.251-20.456,12.738-22.129C139.3,113.739,142.808,119.088,142.246,132.448Zm-16.927,3.639c-.379,9.123.7,14.264,4.506,13.409,4.006-.892,5.361-6.18,5.764-15.693.379-8.94-.647-13.324-4.592-12.432-3.884.867-5.312,6.143-5.679,14.716Z",
    transform: "translate(-118.587 -27.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M149.275,112.384l-1.111,26.465c-.134,3.151.452,6.729,4.445,5.838,3.871-.867,4.824-4.2,4.983-7.9l1.111-26.5,6.509-1.453L164.1,135.441c-.293,6.9-3.065,13.08-11.834,15.046-8.622,1.93-10.918-2.784-10.613-10.027l1.111-26.611,6.509-1.453Z",
    transform: "translate(-113.489 -29.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M171.434,128.913l-.684,16.4-6.46,1.441L165.9,108.3l11.113-2.479c6.595-1.478,10.185,1.331,9.892,8.195-.232,5.557-3.139,8.585-5.068,9.807,2.748.769,3.981,3,3.737,8.683l-.061,1.539a46.156,46.156,0,0,0,.147,7.95l-6.289,1.4c-.452-1.649-.427-4.665-.281-7.975l.061-1.4c.22-5.142-.83-6.631-4.922-5.715l-2.784.623Zm.232-5.581,3.053-.684c3.92-.879,5.532-3,5.691-6.9.134-3.31-1.27-4.9-4.6-4.152l-3.688.818-.452,10.906Z",
    transform: "translate(-108.475 -30.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M194.062,140.48l1.612-38.457,7.376-1.649c6.607,19.577,7.877,23.314,8.243,25.1h.049c-.11-4.568.11-10.222.379-16.524l.44-10.613,5.8-1.295L216.35,135.5l-7.071,1.575c-6.8-20.932-8-24.706-8.4-26.367h-.049c.073,4.69-.159,10.356-.452,17.244l-.476,11.211-5.85,1.307Z",
    transform: "translate(-101.89 -31.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M223.82,124.018l-2.21,10.088-6.509,1.453,10.014-40.338,8.439-1.881,6.888,36.564-6.815,1.527-1.4-9.282-8.4,1.881Zm7.5-7.6c-1.05-7.059-1.905-12.2-2.32-15.742l-.159.037c-.586,3.639-1.978,9.672-3.615,17.073l6.094-1.356Z",
    transform: "translate(-97.233 -32.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M242.785,97.4l-7.755,1.734.256-6.033,22.019-4.922-.256,6.033-7.755,1.734-1.356,32.437-6.509,1.453L242.785,97.4Z",
    transform: "translate(-92.823 -33.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M262.575,87.054l-1.111,26.465c-.134,3.151.452,6.729,4.445,5.838,3.871-.867,4.824-4.2,4.983-7.9L272,84.953l6.509-1.453L277.4,110.111c-.293,6.9-3.065,13.08-11.834,15.046-8.622,1.93-10.918-2.784-10.613-10.027l1.111-26.611,6.509-1.453Z",
    transform: "translate(-88.421 -34.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M284.744,103.583l-.684,16.4-6.46,1.441,1.612-38.457,11.113-2.479c6.595-1.478,10.185,1.331,9.892,8.195-.232,5.557-3.139,8.585-5.068,9.807,2.748.769,3.981,3,3.737,8.683l-.061,1.539a46.159,46.159,0,0,0,.147,7.95l-6.289,1.4c-.452-1.649-.427-4.665-.281-7.975l.061-1.4c.22-5.141-.83-6.631-4.922-5.715l-2.784.623Zm.232-5.569,3.053-.684c3.92-.879,5.532-3,5.691-6.9.134-3.31-1.27-4.9-4.6-4.152l-3.688.83-.452,10.906Z",
    transform: "translate(-83.404 -35.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M305.99,105.658l-2.21,10.088L297.27,117.2l10.014-40.338,8.439-1.881,6.888,36.564-6.815,1.527-1.4-9.282-8.4,1.881Zm7.486-7.6c-1.05-7.059-1.905-12.2-2.32-15.742l-.159.037c-.586,3.639-1.978,9.672-3.615,17.073l6.094-1.356Z",
    transform: "translate(-79.052 -36.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M322.152,73.113l6.509-1.453-1.368,32.583,12.42-2.772-.879,6.021-18.294,4.091,1.612-38.457Z",
    transform: "translate(-73.904 -37.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M353.994,88.1l-.684,16.4-6.46,1.441,1.612-38.457,11.113-2.479c6.595-1.478,10.185,1.331,9.892,8.195-.232,5.557-3.139,8.585-5.068,9.807,2.748.769,3.981,3,3.737,8.683l-.061,1.539a46.152,46.152,0,0,0,.147,7.95l-6.289,1.4c-.452-1.649-.427-4.665-.281-7.975l.061-1.4c.22-5.141-.83-6.631-4.922-5.715l-2.784.623Zm.232-5.569,3.053-.684c3.92-.879,5.532-3,5.691-6.9.134-3.31-1.27-4.9-4.6-4.152l-3.688.818-.452,10.906Z",
    transform: "translate(-68.082 -39.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M375.24,90.178l-2.21,10.088-6.509,1.453,10.014-40.338,8.439-1.881,6.888,36.564-6.815,1.527-1.4-9.282-8.4,1.881Zm7.5-7.6c-1.05-7.059-1.905-12.2-2.32-15.742l-.159.037c-.586,3.639-1.978,9.672-3.615,17.073l6.094-1.356Z",
    transform: "translate(-63.73 -40.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M389.8,96.73l1.612-38.457,7.376-1.649c6.607,19.577,7.889,23.314,8.243,25.1h.049c-.11-4.567.11-10.222.379-16.524l.44-10.613,5.8-1.295L412.09,91.747l-7.071,1.575c-6.8-20.932-8-24.706-8.4-26.367h-.049c.073,4.69-.159,10.356-.452,17.244l-.476,11.211-5.85,1.307Z",
    transform: "translate(-58.581 -41.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M434.819,86.4l-4.958,1.111a29.962,29.962,0,0,1-.171-3.2,10.1,10.1,0,0,1-7.376,5.545c-7.584,1.7-10.027-4.848-9.5-17.342.586-14.044,5.313-21.079,13.1-22.825,9.831-2.2,10,6.607,10.014,8.866L429.507,60c-.037-1.527-.2-5.288-4.03-4.433-4.189.94-5.606,7.108-5.948,15.437-.379,8.964.415,13.666,4.555,12.738,3.444-.769,4.6-3.8,4.836-9.465l.085-2.149-4.885,1.087.244-5.874,11.346-2.54-.9,21.616Z",
    transform: "translate(-53.503 -42.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M454.2,65.252l-11.651,2.6-.464,11.174,13.08-2.919-1.05,6.106L435.43,86.392l1.612-38.457,18.612-4.164-.256,6.021-12.2,2.723-.391,9.367,11.651-2.6-.256,5.972Z",
    transform: "translate(-48.483 -43.77)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurNaturalRange);
export default __webpack_public_path__ + "static/media/Our Natural Range.4bf3c93b84627f27818e427c7de65a1c.svg";
export { ForwardRef as ReactComponent };